import React, { Component, PropTypes } from 'react';

import { uniqueId } from 'lodash';
import { isValid } from '../validate';

import css from './checkbox.scss';

export default class InputCheckbox extends Component {
	static propTypes = {
		name: PropTypes.string.isRequired,
		error: PropTypes.bool,
		validate: PropTypes.array,
		manualValidate: PropTypes.bool,
		onChange: PropTypes.func,
		value: PropTypes.oneOf([0, 1, true, false]),
	};

	static defaultProps = {
		error: undefined,
		value: 0,
		onChange: function() {},
	};

	constructor(props) {
		super();

		this.valid = (typeof props.error === 'undefined') ? true : !props.error;
		this.value = props.value ? 1 : 0;
		this.unique = uniqueId();

		this.state = {
			value: this.value,
			valid: this.valid,
		};
	}

	shouldComponentUpdate(nextProps, nextState) {
		return (
			this.props !== nextProps ||
			this.state.valid !== nextState.valid ||
			this.state.value !== nextState.value
		);
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.value !== this.props.value) {
			this.value = nextProps.value ? 1 : 0;
			this.setState({
				...this.state,
				value: nextProps.value ? 1 : 0,
			});
		}
	}

	render() {
		let labelClassName = 'custom-checkbox';
		let inputClassName = 'custom-checkbox__input';

		if (this.props.className) {
			labelClassName += ' ' + this.props.className;
		}

		if (!this.state.valid || this.props.error) {
			inputClassName += ' custom-checkbox__input--error';
		}

		return (
			<label htmlFor={this.props.name + this.unique} className={labelClassName} onClick={(e) => e.stopPropagation()}>
				{/* output input type text with all the given props as attributes */}
				<input
					ref='input'
					type='checkbox'
					id={this.props.name + this.unique}
					name={this.props.name}
					onChange={(e) => this.onChange(e)}
					className={inputClassName}
					checked={this.state.value}
				/>

				<div className='custom-checkbox__pseudo'></div>

				{/* print label if it exists. */}
				{this.props.children}
			</label>
		);
	}

	onChange(e) {
		if (e && e.target) {
			this.value = e.target.checked ? 1 : 0;
		}

		if (!this.props.manualValidate && this.props.validate) {
			this.valid = isValid(this.value, this.props.validate, this.props.error);
		}

		this.setState({ ...this.state, value: this.value, valid: this.valid });

		this.props.onChange(this.value, e);
	}

	testValidity() {
		this.valid = isValid(this.value, this.props.validate, this.props.error);
		this.setState({ ...this.state, valid: this.valid });

		return this.valid;
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/components/form/input/checkbox.js
 **/